(function () {
  'use strict';

  /* ── Fade-up scroll observer ─────────────────────────── */
  var fadeUpObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      fadeUpObs.unobserve(entry.target);
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('.hj__anim-fadeup').forEach(function (el) {
    fadeUpObs.observe(el);
  });

  /* ── Slide-left scroll observer ──────────────────────── */
  var slideLeftObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      slideLeftObs.unobserve(entry.target);
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('.hj__anim-slide-left').forEach(function (el) {
    slideLeftObs.observe(el);
  });

  /* ── Count-up ─────────────────────────────────────────── */
  function hjCountUp(el, rawTarget, duration) {
    var str          = String(rawTarget);
    var isPercent    = str.indexOf('%') !== -1;
    var isPlus       = str.indexOf('+') !== -1;
    var numericTarget = parseInt(str.replace(/[^0-9]/g, ''), 10);
    if (!numericTarget) return;

    var startTime = performance.now();
    function step(now) {
      var progress = Math.min((now - startTime) / duration, 1);
      var eased    = 1 - Math.pow(1 - progress, 3);
      var current  = Math.floor(eased * numericTarget);
      el.textContent = current + (isPercent ? '%' : '') + (isPlus ? '+' : '');
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var countObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      hjCountUp(el, el.dataset.countTo, 1500);
      countObs.unobserve(el);
    });
  }, { threshold: 0.3 });

  document.querySelectorAll('[data-count-to]').forEach(function (el) {
    countObs.observe(el);
  });

})();
